import { ExportToExcel } from '@/services/excel/generator/excelGenerator';
import ExportExcel from '@/services/excel/generator/exportExcel';
import SheetExcel from '@/services/excel/generator/sheetExcel';
import ColumnExcel from '@/services/excel/generator/columnExcel';

export const columns = [
  new ColumnExcel('Code Dispositif', 'codeDispositif', true),
  new ColumnExcel('Nomenclature', 'nomenclature', true),
  new ColumnExcel('Article', 'Article', false),
  new ColumnExcel('Type profilé face avant', 'Type profilé face avant', false),
  new ColumnExcel('Type profilé face arrière', 'Type profilé face arrière', false),
  new ColumnExcel('Longueur cadre', 'Longueur cadre', false),
  new ColumnExcel('Hauteur cadre', 'Hauteur cadre', false),
  new ColumnExcel('Longueur Toile', 'Longueur Toile', false),
  new ColumnExcel('Hauteur Toile', 'Hauteur Toile', false),
  new ColumnExcel('Support', 'Support', false),
  new ColumnExcel('Type poteau', 'Type poteau', false),
  new ColumnExcel('Double face', 'Double face', false),
  new ColumnExcel('Recto visible de', 'Recto visible de', false),
  new ColumnExcel('Verso visible de', 'Verso visible de', false),
  new ColumnExcel('Distance sol bas du support', 'Distance sol bas du support', false),
  new ColumnExcel('Nature du sol', 'Nature du sol', false),
  new ColumnExcel('Contact installateur', 'Contact installateur', false),
  new ColumnExcel('Emplacement boite elec', 'Emplacement boite elec', false),
  new ColumnExcel('Led', 'Led', false),
  new ColumnExcel('Type led', 'Type led', false),
  new ColumnExcel('distance mur droite', 'distance mur droite', false),
  new ColumnExcel('distance mur gauche', 'distance mur gauche', false),
  new ColumnExcel('nature du mur', 'nature du mur', false),
  new ColumnExcel('Nom emplacement structure', 'Nom emplacement structure', false),
  new ColumnExcel('Longueur suspente acier', 'Longueur suspente acier', false),
  new ColumnExcel('Longueur cable électrique', 'Longueur cable électrique', false),
  new ColumnExcel('Type pieds', 'Type pieds', false),
  new ColumnExcel('Sortie électrique', 'Sortie électrique', false),
  new ColumnExcel('dispositif prêt à brancher', 'dispositif prêt à brancher', false),
  new ColumnExcel('Type écran', 'Type écran', false),
  new ColumnExcel('Couleur poteau', 'Couleur poteau', false),
  new ColumnExcel('Cadre frameup verso', 'Cadre frameup verso', false),
  new ColumnExcel('Orientation', 'Orientation', false),
  new ColumnExcel('Format écran', 'Format écran', false),
  new ColumnExcel('Format vidéo', 'Format vidéo', false),
  new ColumnExcel('Connexion', 'Connexion', false),
  new ColumnExcel('Contact électricien', 'Contact électricien', false),
  new ColumnExcel('Position tête tube', 'Position tête tube', false),
  new ColumnExcel('Platine de fixation', 'Platine de fixation', false),
  new ColumnExcel('Type dispositif', 'Type dispositif', false),
];

export function templateConfig(data) {
  return new ExportExcel(
    'TemplatePatrimoineNomenclature.xlsx',
    [
      new SheetExcel(
        'PatrimoineNomemclature',
        columns,
        data,
        { skipHeader: false },
      ),
    ],
  );
}

export function generatedTemplatePatrimoineNomenclature() {
  const exemple = {
  };
  const config = templateConfig([exemple]);
  ExportToExcel(config);
}
